import { render, staticRenderFns } from "./ProcessReportHeaders.vue?vue&type=template&id=3d00a50c&scoped=true&"
import script from "./ProcessReportHeaders.vue?vue&type=script&lang=js&"
export * from "./ProcessReportHeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d00a50c",
  null
  
)

export default component.exports